module.exports = "/next-static/_next/static/images/hero_image_2x-4b933b5982b79d0542b68d8b34e13f77.webp";